import { ChevronUp, ChevronDown } from 'lucide-react';
import { VoteType } from '../types';
import { cn } from '@/utils';

interface VoteButtonProps {
  upvotes: number;
  downvotes: number;
  userVote: VoteType;
  onVote: (voteType: VoteType) => void;
  compact?: boolean;
}

export function VoteButton({ upvotes, downvotes, userVote, onVote, compact = false }: VoteButtonProps) {
  const score = upvotes - downvotes;
  const isUpvoted = userVote === 'upvote';
  const isDownvoted = userVote === 'downvote';

  const handleUpvote = () => {
    onVote(isUpvoted ? null : 'upvote');
  };

  const handleDownvote = () => {
    onVote(isDownvoted ? null : 'downvote');
  };

  if (compact) {
    // 40px tap targets below 640px; the 24px desktop size was too small to hit
    // reliably with a thumb (T101026002).
    return (
      <div className="flex items-center gap-1">
        <button
          onClick={handleUpvote}
          className={cn(
            "p-3 sm:p-1 rounded-xl transition-colors",
            isUpvoted 
              ? "text-primary bg-primary/10" 
              : "text-foreground/60 hover:text-primary hover:bg-primary/5"
          )}
          aria-label="Upvote"
        >
          <ChevronUp className="h-4 w-4" />
        </button>
        <span className={cn(
          "text-sm font-semibold min-w-[2ch] text-center",
          score > 0 && "text-primary",
          score < 0 && "text-destructive"
        )}>
          {score}
        </span>
        <button
          onClick={handleDownvote}
          className={cn(
            "p-3 sm:p-1 rounded-xl transition-colors",
            isDownvoted 
              ? "text-destructive bg-destructive/10" 
              : "text-foreground/60 hover:text-destructive hover:bg-destructive/5"
          )}
          aria-label="Downvote"
        >
          <ChevronDown className="h-4 w-4" />
        </button>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center gap-1">
      <button
        onClick={handleUpvote}
        className={cn(
          "p-1.5 rounded-xl transition-colors",
          isUpvoted 
            ? "text-primary bg-primary/10" 
            : "text-foreground/60 hover:text-primary hover:bg-primary/5"
        )}
        aria-label="Upvote"
      >
        <ChevronUp className="h-5 w-5" />
      </button>
      <span className={cn(
        "text-sm font-semibold min-w-[2ch] text-center",
        score > 0 && "text-primary",
        score < 0 && "text-destructive"
      )}>
        {score}
      </span>
      <button
        onClick={handleDownvote}
        className={cn(
          "p-1.5 rounded-xl transition-colors",
          isDownvoted 
            ? "text-destructive bg-destructive/10" 
            : "text-foreground/60 hover:text-destructive hover:bg-destructive/5"
        )}
        aria-label="Downvote"
      >
        <ChevronDown className="h-5 w-5" />
      </button>
    </div>
  );
}











